<template>
    <el-aside
        :width="$client.width <= 900 ? '0px' : $store.getters.sideNavHidden ? '0px' : '250px'"
    >
        <div class="logo-container">
            <div class="logo-text text-align-center text-bigger">
                <span class="text-primary">Auto</span>
                <span class="text-white">Damage</span>
            </div>
            <div class="clearfix"></div>
        </div>
        <div
            class="sidenav-menu-modal"
            v-if="$client.width <= 900"
            v-show="!$store.getters.sideNavCollapsed"
            @click="$store.commit('sideNavCollapsed', !$store.getters.sideNavCollapsed)"
        ></div>
        <div :class="{ expanded: !$store.getters.sideNavCollapsed, sidenav: true }">
            <div class="user-avatar p-10px">
                <div class="text-align-center">
                    <img
                        class="avatar"
                        :src="user.photoPath"
                        onerror="this.src = '/static/placeholder-user.png'"
                        width="36"
                        height="36"
                    />
                </div>
                <div class="text-align-center my-5px user-name">
                    {{ user.fullName }}
                </div>
                <div class="text-align-center">
                    <el-popover
                        :open-delay="750"
                        placement="right"
                        width="160"
                        popper-class="break-word"
                        v-model="logoutConfirm"
                    >
                        <p class="text-align-left">Are you sure you want to logout</p>
                        <div class="text-align-right m-0">
                            <a @click="logout">
                                <el-button type="danger" size="mini">Yes</el-button>
                            </a>
                            <el-button size="mini" type="text" @click="logoutConfirm = false"
                                >Cancel</el-button
                            >
                        </div>
                        <el-button
                            slot="reference"
                            class="m-0 p-3px text-decoration-underline text-danger"
                            type="text"
                            size="mini"
                        >
                            <i class="fa fa-sign-out"></i> <span>Logout</span>
                        </el-button>
                    </el-popover>
                </div>
            </div>
            <el-menu
                :default-active="$route.path"
                :class="['sidenav-menu']"
                :router="true"
                ref="nav"
                unique-opened
            >
                <el-menu-item index="/autodamage">
                    <i class="fa fa-group"></i>
                    <span slot="title">Clients</span>
                </el-menu-item>
                <el-menu-item index="/autodamage/damages">
                    <i class="fa fa-group"></i>
                    <span slot="title">Damages</span>
                </el-menu-item>
            </el-menu>
        </div>
    </el-aside>
</template>

<script>
export default {
    name: 'sidenav',
    data() {
        return {
            logoutConfirm: false,
        };
    },
    computed: {
        user() {
            return this.$store.getters.user;
        },
        isAdmin() {
            return this.$store.getters.context.isAdmin;
        },
    },
    watch: {
        $route() {
            this.$nextTick(() => {
                this.$refs.nav.activeIndex = this.$refs.nav.defaultActive;
                if (this.$client.width <= 900) {
                    this.$store.commit('sideNavCollapsed', true);
                }
            });
        },
    },
    methods: {
        logout() {
            this.$gAuth
                .signOut()
                .then(() => {
                    window.localStorage.removeItem('auth_token');
                    window.location.href = '/';
                    this.logoutConfirm = false;
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error.message || 'Some errors occured please try again later.',
                    });
                });
        },
    },
};
</script>

<style lang="scss" scoped>
aside {
    height: 100%;
    overflow: hidden !important;

    .el-scrollbar {
        height: calc(100% - 70px);

        .el-scrollbar__wrap {
            overflow-x: hidden;
        }
    }

    .logo-container {
        height: 69px;
        line-height: 70px;
        background-color: #646464;
        border-bottom: 1px solid #ddd;

        .logo-text {
            font-size: 25px;
        }
    }

    .user-avatar {
        .user-name {
            font-size: 18px;
        }
        border-bottom: 1px solid #eaeaea;
    }

    .sidenav-menu {
        height: calc(100% - 100px);
        overflow-y: hidden;
        border-right: 0px;

        .el-menu-item-group__title {
            font-size: 14px;
        }

        .el-menu-item {
            font-size: 14px;
            line-height: 40px;
            height: 40px;
        }

        .el-submenu {
            .el-submenu__title {
                line-height: 40px;
                height: 40px;
            }
        }
    }
    .sidenav-menu-modal {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: 0.3;
        z-index: 90;
    }
}

@media (max-width: 899px) {
    .sidenav {
        width: 0%;
        transition: width 0.5s;
        &.expanded {
            transition: width 0.5s;
            position: absolute;
            width: 80%;
            z-index: 1500;
            border-right: 1px solid #ddd;
            box-shadow: -2px 0px 4px -2px;
            background: #fff;
            height: calc(100% - 70px);
        }
    }
}
</style>
